import common from '../../common/common';
import { lightenDarkenColor, get } from '../../common/utility';

/**
 * Convert the opacity value to Hexa Decimal
 * @param {Objec} colorObj - Color Object
 */
export const convertOpacityToHex = colorObj => {
  let a = '';
  if (colorObj && colorObj.rgb && colorObj.rgb.hasOwnProperty('a') && colorObj.rgb.a != 1) {
    a = Math.floor(colorObj.rgb.a * 255).toString(16);
    if (a.length === 1) {
      a = `0${a}`;
    }
  }
  return a;
};

/**
 * Common Action for `theme` and `checkout`
 * @param {Object} store - Store Object
 */
export const onChange = () => ({
  /**
   * Update the `preview` as `Mobile` or `Website`
   * @param {Object} state - Store Object
   */
  onPreviewToggle(state, value) {
    return { isMobilePreviewSelected: value };
  },

  /**
   * Update the `preview` Tab as `JS Checkout` or `Redirection`
   * @param {Object} state - State Object
   */
  onPreviewTabChange(state, value) {
    return { isRedirectionTabSelected: value };
  },

  /**
   * Toggle the Key's value as `true` or `false`
   * @param {Object} state - State Object
   * @param {String} key - Key name
   * @param {String} value - Value of Key
   */
  onToggleChange(state, key, value) {
    return { [key]: value };
  },

  /**
   * Update the `theme` as `Light`, `Dark` or `Custom` theme
   * @param {Object} state - Store Object
   * @param {Object} webInfo - webInfo Object
   * @param {Object} mobileInfo - mobileInfo Object
   */
  onThemeChange(state, webInfo, mobileInfo) {
    webInfo.isSelected = true;
    mobileInfo.isSelected = true;
    const selected = { mobile: mobileInfo, web: webInfo, gradient: state.selected.gradient, merchant: state.selected.merchant };
    selected.gradient.buttonGradientsColors = [];
    selected.gradient.headerGradientsColors = [];
    selected.gradient.buttonGradientsColors.push(mobileInfo.PAYBUTTONBG);
    selected.gradient.buttonGradientsColors.push(lightenDarkenColor(mobileInfo.PAYBUTTONBG));
    selected.gradient.headerGradientsColors.push(mobileInfo.HEADERPANEL);
    selected.gradient.headerGradientsColors.push(lightenDarkenColor(mobileInfo.HEADERPANEL));
    return { selected };
  },

  /**
   * Update the `theme` as `Light`, `Dark` or `Custom` theme
   * @param {Object} state - Store Object
   * @param {Object} logoFile - logoFile Object
   */
  onMerchantLogoChange(state, logoFile, logoFileUrl) {
    const selected = { ...state.selected };
    if(!selected.merchant) { selected.merchant = {} }
    selected.merchant.merchantLogoFile = logoFile;
    selected.merchant.merchantLogoUrl = logoFileUrl;
    return { selected };
  },

  /**
   * Update the color of `HEADERPANEL`, `HEADERTEXT`, `PAYBUTTONBG`, `PAYBUTTONTEXT`, `BODYBG`, `BODYTEXT`, `BOTTOMBG`
   * @param {Object} state - Store Object
   * @param {String} type - color code type, like `HEADERPANEL`, `HEADERTEXT`, etc. all six
   * @param {String} color - color code of particular type
   */
  onColorChange(state, type, color) {
    const a = convertOpacityToHex(color);
    const colorObj = { ...state.selected.mobile, [type]: color.hex + a };
    const selected = { mobile: colorObj, web: colorObj, gradient: state.selected.gradient, merchant: state.selected.merchant };

    if (type === 'HEADERPANEL') {
      selected.gradient.headerGradientsColors = [];
      selected.gradient.headerGradientsColors.push(get(selected, 'mobile.HEADERPANEL'));
      selected.gradient.headerGradientsColors.push(lightenDarkenColor(get(selected, 'mobile.HEADERPANEL')));
    }

    if (type === 'PAYBUTTONBG') {
      selected.gradient.buttonGradientsColors = [];
      selected.gradient.buttonGradientsColors.push(get(selected, 'mobile.PAYBUTTONBG'));
      selected.gradient.buttonGradientsColors.push(lightenDarkenColor(get(selected, 'mobile.PAYBUTTONBG')));
    }
    return { selected };
  },

  /**
   * Save the `Custom` theme to persist the changes
   * @param {Object} state - State Object
   * @param {Object} colorObj - Color Object
   */
  onSaveCustomTheme(state, colorObj) {
    return {
      MobileTheme: {
        LIGHTTHEME: state.MobileTheme.LIGHTTHEME,
        DARKTHEME: state.MobileTheme.DARKTHEME,
        CUSTOMTHEME: colorObj.mobile
      },
      WebTheme: {
        LIGHTTHEME: state.WebTheme.LIGHTTHEME,
        DARKTHEME: state.WebTheme.DARKTHEME,
        CUSTOMTHEME: colorObj.web
      }
    };
  },
  /**
   * Update the Payment Mode Order
   * @param {Object} state - State Object
   * @param {Integer} oldIndex - Old Index
   * @param {Integer} newIndex - New Index
   */
  onPaymodeReOrder(state, oldIndex, newIndex) {
    let { merchantPayModes, timestamp } = state;
    if (merchantPayModes) {
      const updateIndexValue = merchantPayModes.splice(oldIndex, 1);
      merchantPayModes.splice(newIndex, 0, updateIndexValue[0]);
      timestamp = new Date().getTime();
      common.log('onPaymodeReorder', updateIndexValue, merchantPayModes);
      return { merchantPayModes, timestamp };
    }
  },

  /**
   * Toggle the Key's value as `true` or `false`
   * @param {Object} state - State Object
   * @param {String} key - Key name
   * @param {String} value - Value of Key
   */
  onKeyValueChange(state, key, value) {
    return { [key]: value };
  }
});



// WEBPACK FOOTER //
// ./controller/theme_checkout/index.js